import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Ensure date strings from SQLite (no timezone indicator) are treated as UTC */
function asUtc(d: string): string {
  if (d.includes('Z') || d.includes('+') || d.includes('T')) return d
  return d.replace(' ', 'T') + 'Z'
}

export function formatDateTime(d: string | null | undefined): string {
  if (!d) return '—'
  return new Date(asUtc(d)).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' })
}

export function formatDate(d: string | null | undefined): string {
  if (!d) return '—'
  return new Date(asUtc(d)).toLocaleDateString('es-ES')
}

export function formatDateShort(d: string | null | undefined): string {
  if (!d) return '—'
  return new Date(asUtc(d)).toLocaleDateString('es-ES', { day: '2-digit', month: 'short' })
}
